export const TOKEN_TYPE = "Bearer ";
export const REQUEST_HEADER_AUTH_KEY = "Authorization";

export const TIMEOUT = 60000;

export const UNAUTHORIZED_CODES = [401];

export const OTP_CODE_LENGTH = 6;
